<template>
    <div class="inner" @click="showTost">
        <div class="top">
            <div class="left">
                <div class="title">
                    学会党的建设
                </div>
                <div class="tit" v-if="jSData.desc">
                    <span class="tit-text">
                        {{ ToText(jSData.desc.title) }}
                    </span>
                    <i class="alert" data-type="jianshe"></i>
                </div>
                <div id="chart1" class="chart"></div>
            </div>
            <div class="right">
                <div class="title">
                    综合业务能力雷达图
                </div>
                <div class="chart" id="chart2"></div>
                <div class="table" v-if="tableData.tableData">
                    <table>
                        <thead>
                            <tr>
                                <th width="30%">
                                    <span class="line"></span>
                                </th>
                                <th v-for="(item,index) in tableData.tableData.column" :key="index">
                                    {{ item }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in tableData.tableData.list" :key="index">
                                <td>
                                    <b>
                                        {{ tableData.tableData.title[index] }}
                                    </b>
                                </td>
                                <td v-for="(i,d) in item" :key="d">
                                    {{ i }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-if="tableData.desc">
                        <thead>
                            <tr>
                                <th>
                                    {{ ToText(tableData.desc.title) }}
                                </th>
                            </tr>
                        </thead>
                        <tr v-for="(item,index) in tableData.desc.list" :key="index">
                            <td>
                                <p class="type">
                                    【{{ item.title }}】
                                </p>
                                打败了
                                <i>
                                    {{ item.percentage }}
                                </i>
                                学会，
                                <b>
                                    {{ item.desc }}
                                </b>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
        <div class="bottom">
            <div class="title" @click="tableChange">
                <span :class="type=='基础保障'?'active':''" data-type="基础保障">
                    基础保障
                </span>
                <span :class="type=='学术发展'?'active':''" data-type="学术发展">
                    学术发展
                </span>
                <span :class="type=='智库建设'?'active':''" data-type="智库建设">
                    智库建设
                </span>
                <span :class="type=='科学普及'?'active':''" data-type="科学普及">
                    科学普及
                </span>
                <span :class="type=='学会改革创新工作'?'active':''" data-type="学会改革创新工作">
                    学会改革创新工作
                </span>
            </div>
            <div class="chart-content">
                <div class="type1" v-if="type=='基础保障'&&bottomData.基础保障">
                    <div class="part">
                        <h3 class="subtitle">
                            基础保障
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.基础保障[0].desc.title) }}
                            </span>
                            <i class="alert" data-type="基础保障" data-index="0"></i>
                        </div>
                        <div id="chart3" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            组织建设
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.基础保障[1].desc.title) }}
                            </span>
                            <i class="alert" data-type="基础保障" data-index="1"></i>
                        </div>
                        <div id="chart4" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            会员发展和服务
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.基础保障[2].desc.title) }}
                            </span>
                            <i class="alert" data-type="基础保障" data-index="2"></i>
                        </div>
                        <div id="chart5" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            社会资源动员
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.基础保障[3].desc.title) }}
                            </span>
                            <i class="alert" data-type="基础保障" data-index="3"></i>
                        </div>
                        <div id="chart6" class="chart"></div>
                    </div>
                </div>
                <div class="type2" v-if="type=='学术发展'">
                    <div class="part">
                        <h3 class="subtitle">
                            学术交流与合作
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.学术发展[0].desc.title) }}
                            </span>
                            <i class="alert" data-type="学术发展" data-index="0"></i>
                        </div>
                        <div id="type2Chart1" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            学术交流与合作
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.学术发展[1].desc.title) }}
                            </span>
                            <i class="alert" data-type="学术发展" data-index="1"></i>
                        </div>
                        <div id="type2Chart2" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            学术评价
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.学术发展[2].desc.title) }}
                            </span>
                            <i class="alert" data-type="学术发展" data-index="2"></i>
                        </div>
                        <div id="type2Chart3" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            学术规范
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.学术发展[3].desc.title) }}
                            </span>
                            <i class="alert" data-type="学术发展" data-index="3"></i>
                        </div>
                        <div id="type2Chart4" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            服务创新发展
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.学术发展[4].desc.title) }}
                            </span>
                            <i class="alert" data-type="学术发展" data-index="4"></i>
                        </div>
                        <div id="type2Chart5" class="chart"></div>
                    </div>
                </div>
                <div class="type3" v-if="type=='智库建设'">
                    <div class="part">
                        <h3 class="subtitle">
                            智库建设
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.智库建设[0].desc.title) }}
                            </span>
                            <i class="alert" data-type="智库建设" data-index="0"></i>
                        </div>
                        <div id="type3Chart1" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            服务科学决策
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.智库建设[1].desc.title) }}
                            </span>
                            <i class="alert" data-type="智库建设" data-index="1"></i>
                        </div>
                        <div id="type3Chart2" class="chart"></div>
                    </div>
                </div>
                <div class="type4" v-if="type=='科学普及'">
                    <div class="part">
                        <h3 class="subtitle">
                            科学普及
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.科学普及[0].desc.title) }}
                            </span>
                            <i class="alert" data-type="科学普及" data-index="0"></i>
                        </div>
                        <div id="type4Chart1" class="chart"></div>
                    </div>
                    <div class="part">
                        <h3 class="subtitle">
                            服务科学素质提升
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.科学普及[1].desc.title) }}
                            </span>
                            <i class="alert" data-type="科学普及" data-index="1"></i>
                        </div>
                        <div id="type4Chart2" class="chart"></div>
                    </div>
                </div>
                <div class="type5" v-if="type=='学会改革创新工作'">
                    <div class="part">
                        <h3 class="subtitle">
                            学会创新工作
                        </h3>
                        <div class="tit">
                            <span class="tit-text">
                                {{ ToText( bottomData.学会改革创新工作[0].desc.title) }}
                            </span>
                            <i class="alert" data-type="学会改革创新工作" data-index="0"></i>
                        </div>
                        <div id="type5Chart1" class="chart"></div>
                    </div>
                </div>
            </div>
        </div>
        <table class="tost" :class="tostFlag?'':'tost-hide'" :style="styles" ref="tost">
            <tr>
                <th></th>
                <th>打败学会(%)</th>
                <th>评价</th>
            </tr>
            <tr v-for="(item, index) in descData" :key="index">
                <td>{{ item.title }}</td>
                <td>{{ item.percentage }}</td>
                <td>{{ item.desc }}</td>
            </tr>
        </table>
    </div>
</template>
<script>
    import * as dataJS from '@/assets/scripts/api/xhqj';
    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const barColor = ['#4256d4', '#05c0fb', '#30cf70', '#ef9412', '#fb058f'];
    const pieColor = ['#FB058F', '#06C0FB', '#0078FF', '#344DD5', '#EF9412', '#30CF70'];
    const rabarColor = [
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        }
    ];

    const GRID = {
        left: '5%',
        top: '8%',
        bottom: '20%',
        right: '5%',
        containLabel: true
    };
    const xAxis = {
        type: 'category',
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 14
            }
        },
        axisLine: {
            lineStyle: {
                color: lineColor
            }
        },
        axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
                color: lineColor,
            }
        }
    };

    const yAxis = {
        axisTick: {
            show: false
        },
        axisLine: {
            show: false
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: lineColor,
                type: 'dotted'
            }
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 12
            },
            formatter: '{value}'
        }
    };


    export default {
        name: 'xhpm',
        data() {
            return {
                name: '',
                type: '基础保障',
                tostFlag: false,
                hasDesc: false,
                jSData: {},
                chartData: [],
                tableData: {},
                bottomData: {},
                descData: [],
                allData: [],
                styles: {
                    left: 0,
                    top: 0
                }
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.name = this.$route.query.nav;

                dataJS.getCrowdDetailById(this.$route.query.id).then((res) => {
                    this.allData = res.data;
                    this.jSData = this.allData.jianshe;
                    this.tableData = this.allData.leida_right;
                    this.bottomData = this.allData.bottom;
                    this.chartData = this.bottomData[this.type];

                    this.chartData.forEach((item) => {
                        if (item.desc) {
                            this.hasDesc = true;
                        }
                    });

                    this.$nextTick(() => {
                        this.initChart1();
                        this.initchart2();
                        this.initType1Chart();
                    });
                });
            },
            showTost(e) {

                if (e.target.className == 'alert') {
                    let w,
                        h,
                        {type, index} = e.target.dataset;

                    if (type == 'jianshe') {
                        this.descData = this.allData[type].desc.list;
                    } else {
                        this.descData = this.bottomData[type][index].desc.list;
                    }

                    this.$nextTick(() => {
                        w = this.$refs.tost.clientWidth;
                        h = this.$refs.tost.clientHeight;

                        this.tostFlag = true;
                        this.styles.left = e.pageX - w + 'px';
                        this.styles.top = e.pageY - h + 'px';
                    });

                } else {
                    this.tostFlag = false;
                }

            },
            tableChange(e) {

                if (e.target.nodeName == 'SPAN') {
                    this.type = e.target.dataset.type ? e.target.dataset.type : '基础保障';
                    this.chartData = this.bottomData[this.type];
                }

                this.$nextTick(() => {

                    switch (this.type) {
                    case '基础保障':
                        this.initType1Chart();
                        break;
                    case '学术发展':
                        this.initType2Chart();
                        break;
                    case '智库建设':
                        this.initType3Chart();
                        break;
                    case '科学普及':
                        this.initType4Chart();
                        break;
                    case '学会改革创新工作':
                        this.initType5Chart();
                        break;
                    }
                });
            },
            initType1Chart() {
                let chart3 = echarts.init(document.getElementById('chart3')),
                    option3 = this.getRadarOption(this.chartData[0].data, 3),
                    chart4 = echarts.init(document.getElementById('chart4')),
                    option4 = this.getOptionData(this.chartData[1].data),
                    chart5 = echarts.init(document.getElementById('chart5')),
                    option5 = this.getOptionData(this.chartData[2].data),
                    chart6 = echarts.init(document.getElementById('chart6')),
                    option6 = this.getPieOption(this.chartData[3].data);


                chart3.setOption(option3, true);
                chart3.resize();
                this.$winResize(chart3.resize);

                chart4.setOption(option4, true);
                chart4.resize();
                this.$winResize(chart4.resize);


                chart5.setOption(option5, true);
                chart5.resize();
                this.$winResize(chart5.resize);

                chart6.setOption(option6, true);
                chart6.resize();
                this.$winResize(chart6.resize);
            },
            initType2Chart() {
                let chart1 = echarts.init(document.getElementById('type2Chart1')),
                    option1 = this.getRadarOption(this.chartData[0].data, 3),
                    chart2 = echarts.init(document.getElementById('type2Chart2')),
                    option2 = this.getOptionData(this.chartData[1].data),
                    chart3 = echarts.init(document.getElementById('type2Chart3')),
                    option3 = this.getOptionData(this.chartData[2].data),
                    chart4 = echarts.init(document.getElementById('type2Chart4')),
                    option4 = this.getOptionData(this.chartData[3].data),
                    chart5 = echarts.init(document.getElementById('type2Chart5')),
                    option5 = this.getOptionData(this.chartData[4].data);


                chart1.setOption(option1, true);
                chart1.resize();
                this.$winResize(chart1.resize);

                chart2.setOption(option2, true);
                chart2.resize();
                this.$winResize(chart2.resize);

                chart3.setOption(option3, true);
                chart3.resize();
                this.$winResize(chart3.resize);

                chart4.setOption(option4, true);
                chart4.resize();
                this.$winResize(chart4.resize);

                chart5.setOption(option5, true);
                chart5.resize();
                this.$winResize(chart5.resize);

            },
            initType3Chart() {
                let chart1 = echarts.init(document.getElementById('type3Chart1')),
                    option1 = this.getPieOption(this.chartData[0].data, 3),
                    chart2 = echarts.init(document.getElementById('type3Chart2')),
                    option2 = this.getOptionData(this.chartData[1].data, 4);

                chart1.setOption(option1, true);
                chart1.resize();
                this.$winResize(chart1.resize);

                chart2.setOption(option2, true);
                chart2.resize();
                this.$winResize(chart2.resize);
            },
            initType4Chart() {
                let chart1 = echarts.init(document.getElementById('type4Chart1')),
                    option1 = this.getPieOption(this.chartData[0].data, 3),
                    chart2 = echarts.init(document.getElementById('type4Chart2')),
                    option2 = this.getOptionData(this.chartData[1].data, 4);

                chart1.setOption(option1, true);
                chart1.resize();
                this.$winResize(chart1.resize);

                chart2.setOption(option2, true);
                chart2.resize();
                this.$winResize(chart2.resize);
            },
            initType5Chart() {
                let chart1 = echarts.init(document.getElementById('type5Chart1')),
                    option1 = this.getPieOption(this.chartData[0].data, 3);

                chart1.setOption(option1, true);
                chart1.resize();
                this.$winResize(chart1.resize);
            },
            initChart1() {
                let chart = echarts.init(document.getElementById('chart1')),
                    option = this.getOptionData(this.jSData.data,1);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initchart2() {
                let chart2 = echarts.init(document.getElementById('chart2')),
                    option = this.getRadarOption(this.allData.leida_left, 2);

                chart2.setOption(option, true);
                chart2.resize();
                this.$winResize(chart2.resize);
            },
            getPieOption(data) {
                let seriesData = [],
                    option = {};

                data.list.forEach((item, index) => {
                    let obj = {};

                    obj.value = parseFloat(item);
                    obj.name = data.column[index];

                    if (index == 0) {
                        obj.selected = true;
                    }
                    seriesData.push(obj);
                });

                option = {
                    color: pieColor,
                    series: [{
                        name: '',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: [0, '50%'],
                        data: seriesData
                    }]
                };

                return option;
            },
            getRadarOption(data) {
                let indicatorData = this.getchartData(data),
                    option = {},
                    lengendData = [];

                let seriesData = data.list.map((item, index) => {

                    lengendData.push({
                        name: data.title[index],
                        icon: 'circle',
                        textStyle: {
                            color: labelColor,
                            margin: 7
                        }
                    })

                    return {
                        type: 'radar',
                        name: data.title[index],
                        data: [item],
                        symbolSize: 8,
                        lineStyle: {
                            color: rabarColor[index].line
                        },
                        areaStyle: {
                            color: rabarColor[index].line,
                            opacity: 0.5
                        },
                        itemStyle: {
                            color:rabarColor[index].line,
                            borderWidth: 2
                        }
                    }
                })

                option = {
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 12,
                        itemHeight: 12,
                        itemGap: 20,
                        bottom: '3%',
                        data: lengendData
                    },
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    radar: {
                        radius: '60%',
                        splitNumber: 2,
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        splitArea: false,
                        splitLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        name: {
                            textStyle: {
                                color: labelColor,
                                padding: [3, 5]
                            },
                            formatter: function (value) {
                                if (value.length > 4) {
                                    value = value.slice(0, 3) + '\n' + value.slice(3);
                                }
                                return value;
                            },
                        },
                        indicator: indicatorData
                    },
                    series: seriesData
                };

                return option;
            },
            getchartData(data) {
                let indicatorData = [];

                let numData = data.list.map((item) => {
                    return Math.max.apply(null, item);
                })

                data.column.forEach((item) => {
                    let max = Math.max.apply(null, numData),
                        obj = {
                            name: item,
                            max: max
                        };

                    indicatorData.push(obj);
                });

                return indicatorData;
            },
            getOptionData(data, type) {
                let seriesData = [],
                    lengendData = [],
                    option;

                data.list.forEach((item, index) => {
                    seriesData.push({
                        type: 'bar',
                        barWidth: '15%',
                        barGap: 1,
                        name: data.title[index],
                        itemStyle: {
                            normal: {
                                show: true,
                                color: barColor[index],
                                label: {
                                    show: false
                                }
                            }
                        },
                        data: item
                    });
                    lengendData.push({
                        name: data.title[index],
                        textStyle: {
                            color: barColor[index]
                        }
                    });
                });

                option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: GRID,
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 12,
                        itemHeight: 12,
                        padding:[0 ,0],
                        itemGap: 5,
                        bottom: type?'10%':'6%',
                        data: lengendData
                    },
                    xAxis:  Object.assign({
                        data: data.column
                    }, xAxis),
                    yAxis: yAxis,
                    series: seriesData
                };

                return option;
            },
            ToText(HTML){
                var input = HTML;
                return input.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ');
            }

        }
    };
</script>
<style lang="scss" scoped>
    @import "@/assets/scss/mixins/_mixins.scss";

    $labelColor: #ffbf2e;
    $titleColor: #B5C8FF;
    $borderColor: #17215F;
    $borderDrakColor: #080B26;
    $textYellow:#ffc02f;
    $textBlue:#3f91f5;

    .inner {
        padding: 2% 2.08% 0;
        font-size:.16rem;

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .chart {
            width: 100%;
            height: calc(100% - 34px);
        }

        .top {
            height: 50%;
        }

        .bottom {
            height: 50%;
        }


        .tit{
            margin-top: .2rem;
            height:.3rem;
            line-height:.3rem;
            text-align: center;
            color: $titleColor;
            position: relative;
            @include text-ellipsis;

            .tit-text i{
                color: $textYellow;
            }

            .alert{
                display: inline-block;
                width: 18px;
                height: 18px;
                vertical-align: middle;
                cursor: pointer;
                background: url(~@/assets/images/alert.png) no-repeat center center;
                @include position(absolute, 0, 5%, auto, auto);
            }
        }
    }

    table.tost {
        overflow: hidden;
        border: 1px solid $borderColor;
        color: $titleColor;
        background: rgba(0, 0, 0, .7);
        z-index: 99;
        @include position(absolute, 40px, 5%, auto, auto);
        tr {

        }
        th, td {
            text-align: center;
            line-height: .4rem;
            padding: 0 .2rem;
        }
    }

    .tost-hide {
        visibility: hidden;
    }

    .top {
        .left {
            float: left;
            width: 30%;
            height: 100%;
            padding-right: .4rem;

            .title {
                text-align: left;
                font-size: .18rem;
                font-weight: bold;
                color: $titleColor;
                line-height: .6rem;
                height: .6rem;
                padding-left: 2.9%;
                position: relative;
                background-image: linear-gradient(90deg, #181f54, #141b4d);
            }


            .chart{
                height: calc(100% - 1.1rem);
            }

        }

        .right {
            @extend .left;
            width: 70%;
            float: right;

            .chart {
                width: 40.32258065%;
                float: left;
            }
            .table {
                width: 59.67741935%;
                height: calc(100% - .6rem);
                float: left;
                font-size: .16rem;

                table:first-child {
                    width: 55%;
                    height: 100%;
                    text-align: center;
                    color: $titleColor;
                    float: left;
                }
                table:last-child {
                    width: 45%;
                    height: 100%;
                    text-align: center;
                    color: $titleColor;
                    float: right;
                    border-left: 1px solid $borderColor;
                    td {
                        border: none;
                    }

                }
                thead th {
                    height: 60px;
                    border-left: 1px solid $borderColor;
                    border-bottom: 1px solid $borderColor;
                    &:nth-child(2) {
                        color: $textYellow;
                    }
                }

                .line {
                    transform: rotate(20deg);
                    display: block;
                    width: 100%;
                    height: 1px;
                    background: $borderColor;
                }
                tbody {
                    height: calc(100% - 60px);
                }
                tr {
                    &:last-child {
                        td {
                            border-bottom: none;
                        }
                    }
                }
                td {
                    height: 16.6666%;
                    border-left: 1px solid $borderColor;
                    border-bottom: 1px solid $borderColor;
                    &:last-child {
                        border-right: none;
                    }
                    &:nth-child(2) {
                        color: $textYellow;
                    }
                }
                i {
                    color: $textYellow;
                }
                b {
                    color: $textBlue;
                }
                .type {
                    color: #38c6de;
                }
            }
        }

    }

    .bottom {
        padding-right: .4rem;

        .title{
            height: .6rem;
            overflow: hidden;
            box-sizing: border-box;
            background-image: linear-gradient(90deg, #181f54, #141b4d);

            span {
                float: left;
                border: 1px solid $textYellow;
                color: $textYellow;
                border-radius: 10px;
                height:.4rem;
                line-height:.4rem;
                padding:0 .2rem;
                margin: .1rem .2rem;
                cursor: pointer;

                &:hover,
                &.active{
                    color: #333;
                    background: linear-gradient(180deg,$labelColor,#e67c0c);
                }
            }
        }

        .chart-content {
            height: calc(100% - .6rem);

            div{
                height: 100%;

                .subtitle{
                    margin-top: .2rem;
                    height:.4rem;
                    line-height:.4rem;
                    text-align: center;
                    font-size: .26rem;
                    font-weight: bold;
                    color: $titleColor;
                    @include text-ellipsis;
                }

                .tit{
                    height:.3rem;
                    line-height:.3rem;
                    text-align: center;
                    font-size: .2rem;
                    color: $titleColor;
                    position: relative;
                    @include text-ellipsis;
                }

                .chart{
                    height:calc(100% - 1rem);
                }
            }
        }

        .type2 .part {
            width: 20%;
        }

        .type3 .part {
            width: 50%;
            table.tost {
                @include position(absolute, 95px, 20%, auto, auto);
            }
        }
        .type4 .part {
            width: 50%;
            table.tost {
                @include position(absolute, 95px, 20%, auto, auto);
            }
        }
        .type5 .part {
            width: 50%;
            margin: 0 auto;
            float: none;
            table.tost {
                @include position(absolute, 70px, 20%, auto, auto);
            }
        }
        .part {
            width: 25%;
            height: 100%;
            float: left;
            border-right: 1px solid #2b42a2;
            &:last-child {
                border: none;
            }
            .chart {
                height: calc(100% - 90px);
            }
        }
    }
</style>